// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import { debug } from "../debug"

// Log all registered controllers for debugging
debug("Stimulus application started. Registered controllers:", application.controllerDefinitions);

import AccordionItemController from "./accordion_item_controller"
application.register("accordion-item", AccordionItemController)

import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

import BookingIframeController from "./booking_iframe_controller"
application.register("booking-iframe", BookingIframeController)

import ChatButtonController from "./chat_button_controller"
application.register("chat-button", ChatButtonController)

// ChatController removed - unused in production (only used in development/testing views)
// import ChatController from "./chat_controller"
// application.register("chat", ChatController)

import ChatQueryController from "./chat_query_controller"
application.register("chat-query", ChatQueryController)

import ClickableCardController from "./clickable_card_controller"
application.register("clickable-card", ClickableCardController)

import EmojiToolbarController from "./emoji_toolbar_controller"
application.register("emoji-toolbar", EmojiToolbarController)

import FaqSearchController from "./faq_search_controller"
application.register("faq-search", FaqSearchController)

// GlobalChatController removed - no longer needed
// import GlobalChatController from "./global_chat_controller"
// application.register("global-chat", GlobalChatController)

import IframeLoaderController from "./iframe_loader_controller"
application.register("iframe-loader", IframeLoaderController)

import InlineChatController from "./inline_chat_controller"
application.register("inline-chat", InlineChatController)

import MobileTocController from "./mobile_toc_controller"
application.register("mobile-toc", MobileTocController)


import MobileChatController from "./mobile_chat_controller"
application.register("mobile-chat", MobileChatController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import SickLeaveFormController from "./sick_leave_form_controller"
application.register("sick-leave-form", SickLeaveFormController)

import LiveSearchController from "./live_search_controller"
application.register("live-search", LiveSearchController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import FoldsController from "./folds_controller"
application.register("folds", FoldsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

